import React from 'react';

const Row = ({children, className, ...rest}) => (
  <div 
    className={`row${className ? ' ' + className : ''}`} 
    {...rest}
  >
    {children}
  </div>
)

export default Row;